/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
;

/***/ }),

/***/ "./node_modules/smooth-zoom/dist/zoom.esm.js":
/*!***************************************************!*\
  !*** ./node_modules/smooth-zoom/dist/zoom.esm.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Zoom)
/* harmony export */ });
function Zoom(target, options = {}) {
  const originalizer = options.originalizer || (src => src);

  const screenSize = {
    screenWidth: 0,
    screenHeight: 0,
    scrollBar: 0
  };
  const background = options.background;

  const updateScreenSize = () => {
    const {
      documentElement
    } = document;
    screenSize.screenWidth = window.innerWidth || documentElement.clientWidth;
    screenSize.screenHeight = window.innerHeight || documentElement.clientHeight;
    screenSize.scrollBar = screenSize.screenWidth - documentElement.offsetWidth;
  };

  const zoom = image => {
    const src = image.currentSrc || image.src;
    const {
      srcset
    } = image;
    const {
      screenWidth,
      screenHeight,
      scrollBar
    } = screenSize;
    const {
      width,
      height,
      left,
      top
    } = image.getBoundingClientRect();
    const wrapX = (screenWidth - scrollBar) / 2 - left - width / 2;
    const wrapY = -top + (screenHeight - height) / 2;
    const bg = document.createElement("div");
    const imageClone = document.createElement("img");
    let maxWidth = image.naturalWidth;

    const removeImage = () => {
      bg.classList.remove("zoom-bg--reveal");
      imageClone.style.transform = "";
      imageClone.addEventListener("transitionend", () => {
        bg.remove();
        image.classList.remove("zoom-original--hidden");
        imageClone.remove();
      }, {
        once: true
      });
      bg.removeEventListener("click", removeImage);
      imageClone.removeEventListener("click", removeImage);
      window.removeEventListener("scroll", removeImage);
      window.removeEventListener("resize", removeImage);
    };

    bg.classList.add("zoom-bg");

    if (background) {
      if (background === "auto") {
        const average = getAverageRGB(image);
        bg.style.background = average ? `rgb(${average.r}, ${average.g}, ${average.b})` : "rgb(0, 0, 0)";
      } else {
        bg.style.background = background;
      }
    }

    if (srcset) {
      const sizes = srcset.match(/ ([0-9]+)w/gm);

      if (sizes) {
        // Find image's largest width in 'srcset' attribute
        maxWidth = sizes.map(x => +x.trim().replace("w", "")).filter(x => !isNaN(x)).reduce((acc, cur) => Math.max(acc, cur), 0);
      }
    }

    const ratio = height / width; // Image's width shouldn't be larger than screen width

    maxWidth = Math.min(maxWidth, screenWidth); // And height too

    const maxHeight = maxWidth * ratio;

    if (maxHeight >= screenHeight) {
      maxWidth = maxWidth * screenHeight / maxHeight;
    }

    imageClone.classList.add("zoom-img");
    imageClone.src = src;
    imageClone.width = width;
    imageClone.height = height;
    bg.addEventListener("click", removeImage, {
      once: true
    });
    imageClone.addEventListener("click", removeImage, {
      once: true
    });
    window.addEventListener("scroll", removeImage, {
      once: true,
      passive: true
    });
    window.addEventListener("resize", removeImage, {
      once: true,
      passive: true
    });
    document.body.append(bg, imageClone); // Added here for causing style recalculation

    imageClone.style.top = `${top + window.scrollY}px`;
    imageClone.style.left = `${left}px`;
    imageClone.style.width = `${width}px`;
    imageClone.style.height = `${height}px`; // Hide original image

    image.classList.add("zoom-original--hidden"); // Reveal and center cloned image, scale up if needed

    const scale = maxWidth !== width ? maxWidth / width : 1;
    imageClone.style.transform = `matrix(${scale}, 0, 0, ${scale}, ${wrapX}, ${wrapY})`;
    bg.classList.add("zoom-bg--reveal");
    imageClone.addEventListener("transitionend", () => {
      // Replace image's source to original source
      imageClone.src = originalizer(src);
    }, {
      once: true
    });
  };

  const handleClick = event => {
    zoom(event.target);
  };

  const getAverageRGB = img => {
    const blockSize = 5;
    const rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    const width = canvas.width = img.naturalWidth || img.offsetWidth || img.width;
    const height = canvas.height = img.naturalHeight || img.offsetHeight || img.height;
    let data;
    let i = -4;
    let length;
    let count = 0;
    ctx.drawImage(img, 0, 0);

    try {
      data = ctx.getImageData(0, 0, width, height);
    } catch (e) {
      return null;
    }

    length = data.data.length;

    while ((i += blockSize * 4) < length) {
      ++count;
      rgb.r += data.data[i];
      rgb.g += data.data[i + 1];
      rgb.b += data.data[i + 2];
    }

    rgb.r = Math.floor(rgb.r / count);
    rgb.g = Math.floor(rgb.g / count);
    rgb.b = Math.floor(rgb.b / count);
    return rgb;
  };

  const attach = target => {
    if (!target) return;

    if (typeof target === "string") {
      document.querySelectorAll(target).forEach(addZoomEvent);
    } else if (target instanceof HTMLElement) {
      addZoomEvent(target);
    } else if (target instanceof NodeList || target instanceof Array) {
      target.forEach(addZoomEvent);
    } // Add cursor style for target


    if (typeof target === "string") {
      const style = document.createElement("style");
      const head = document.head || document.getElementsByTagName("head")[0];
      style.appendChild(document.createTextNode(`${target}{cursor:zoom-in}`));
      head.appendChild(style);
    }
  };

  const addZoomEvent = element => {
    if (!(element instanceof HTMLElement)) return;

    if (element.tagName === "IMG") {
      element.addEventListener("click", handleClick);
    } else {
      const childImg = element.querySelector("img");

      if (childImg) {
        childImg.addEventListener("click", handleClick);
      }
    }
  };

  updateScreenSize();
  window.addEventListener("resize", updateScreenSize, {
    passive: true
  });
  attach(target);
  return {
    zoom,
    attach
  };
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".zoom-bg,.zoom-img{cursor:zoom-out;z-index:90000}.zoom-img{display:block;position:absolute;transition:transform .3s ease-in-out;will-change:transform}.zoom-bg{background:#121212;height:100vh;left:0;opacity:0;position:fixed;top:0;transition:opacity .3s ease-in-out;width:100vw;will-change:opacity}.zoom-bg.zoom-bg--reveal{opacity:.95}.zoom-original--hidden{visibility:hidden}";
styleInject(css_248z);




/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!***************************!*\
  !*** ./src/js/product.js ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var smooth_zoom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! smooth-zoom */ "./node_modules/smooth-zoom/dist/zoom.esm.js");
/* harmony import */ var _formatMoney__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./formatMoney */ "./src/js/formatMoney.js");



/*
 BG: Init smooth-zoom, just apply the class below a zoomable image
https://github.com/marshall-ku/smooth-zoom
 */
(0,smooth_zoom__WEBPACK_IMPORTED_MODULE_0__["default"])(".zoomable");

/**
 * BG: This is a BIG function, that has alot of smaller functions. The whole purpose of this is to determine the variant options the user has selected, while highlighting the available and unavailable variants after each choice they make, and updating the price, and variant id field. This function works best when we have the first available variants selected.
 */

var productBuyBoxes = document.querySelectorAll('.product-variants');
var _loop = function _loop(i) {
  var productVariants = function productVariants() {
    var productVariants = productBuyBoxes[i];
    var userSelect = productVariants.querySelectorAll('.user-select');
    var variantFieldsets = productVariants.querySelectorAll('.product-container fieldset');
    var masterVariantField = document.querySelectorAll('.product-container form[action*="/cart/add"] input[name="id"]');
    var cartBtn = document.querySelectorAll('.product-container [action*="/cart/add"] button[type="submit"]');
    var qtySelector = document.querySelectorAll('.product-container [action*="/cart/add"] .js-prod-qty-selector');
    var notifyBtn = document.querySelectorAll('.product-container [action*="/cart/add"] .btn-notify-me');

    //get the variantData from the json markup.
    var getVariantData = function getVariantData() {
      return JSON.parse(productVariants.querySelector('[type="application/json"]').textContent);
    };

    //Debug
    //console.log(JSON.parse(productVariants.querySelector('[type="application/json"]').textContent));

    //BG: When the user makes a selection, update the field legend to include that choice.
    /**
     * 
     * @param {*} radio | Node - Passed when the user selects a radio on variant selector.
     */
    var fieldsetLegend = function fieldsetLegend(radio) {
      var parentLegend = radio.closest('fieldset');
      var legendLabel = parentLegend.querySelector('legend').getAttribute('data-fieldset-label');
      parentLegend.querySelector('legend span').innerHTML = legendLabel + ': ' + '<span class="js-variant-value uppercase font-bold">' + radio.value + '</span>';
    };

    //BG: Triggered by the finalVariant function, we determine if the final variant Id selected is available or not, and update the button to reflect that choice.
    var addToBagBtn = function addToBagBtn(available) {
      if (available) {
        cartBtn.forEach(function (element) {
          element.classList.remove('hidden');
        });
        qtySelector.forEach(function (elem) {
          elem.classList.remove('hidden');
        });
        notifyBtn.forEach(function (btn) {
          btn.classList.add('hidden');
        });
      } else {
        cartBtn.forEach(function (element) {
          element.classList.add('hidden');
        });
        qtySelector.forEach(function (elem) {
          elem.classList.add('hidden');
        });
        notifyBtn.forEach(function (btn) {
          btn.classList.remove('hidden');
        });
      }
    };

    //BG: the finalVariant funciton below will trigger this function, we essentially need the variant ID to query the price
    var variantPrice = function variantPrice(variantId) {
      var productPrice = document.querySelector('.js-product-price');
      var productCAP = document.querySelector('.js-product-compare-at-price');
      var variantData = getVariantData().filter(function (variant) {
        return variant.id === variantId;
      });
      var productServing = document.querySelectorAll('.per-serving');
      var targetID = variantData[0].id.toString();
      productServing.forEach(function (serving) {
        var servingID = serving.getAttribute('data-variant-serving');
        if (targetID === servingID) {
          serving.classList.remove('hidden');
        } else {
          serving.classList.add('hidden');
        }
      });

      //Update the product price, with the selected variant, and format the money.
      productPrice.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variantData[0].price, window.theme.moneyFormat);

      //Is there a Compare at price (CAP)? if so, let's update that too. 
      if (variantData[0].compare_at_price != null) {
        //if CAP does exist, remove the hidden class if present.
        productCAP.classList.remove('hidden');
        //Update the CAP, with the selected variant, and format the money.
        productCAP.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variantData[0].compare_at_price, window.theme.moneyFormat);
      } else {
        //No CAP?, No Problem, let's just hide it.
        productCAP.classList.add('hidden');
      }
    };

    /**
     * BG: Once the user has selected all variant options, this function then triggers to update the variant ID field, price and url based on the users choice. 
     */
    var finalVariant = function finalVariant(variant) {
      //BG: let's update the id input to the selected variant id
      masterVariantField.forEach(function (element) {
        element.value = variant.id;
      });
      //BG: Trigger the price update based on the variant ID
      variantPrice(variant.id);
      //BG: Update the add to bag btn based on the variant being available or not.
      addToBagBtn(variant.available);

      //Update the url with the user's variant choice.
      //Get the current URL without parameters
      var currentURLWithoutParams = window.location.href.split('?')[0];
      //update the page url with paramters
      history.pushState(null, null, currentURLWithoutParams + '?variant=' + variant.id);
    };

    /**
     * BG: There's a lot going on here, basically we determine how many variant options there are, and based on how many options there are, will determine the logic and approach. Essentially, we're determining what options are available or not available based on the user's choice. 
     * checkedBtns(Array) - Checked radio buttons.
     */
    var remainingOptions = function remainingOptions(checkedBtns) {
      //If only one variant, remove all unavailable classes.
      if (variantFieldsets.length === 1) {
        productVariants.querySelectorAll('.js-unavailable-variant').forEach(function (label) {
          label.classList.remove('js-unavailable-variant');
        });
      }

      // for each checked radio button.
      checkedBtns.forEach(function (radio, index) {
        //First fieldset option
        if (index === 0) {
          // console.log('fire option 1');
          var remainingVariants;
          //if only one variant, then find all the unavailable variants
          if (variantFieldsets.length === 1) {
            remainingVariants = getVariantData().filter(function (variant) {
              return variant.available === false;
            });
          } else if (variantFieldsets.length === 2) {
            //if two variants, then find all the variants from option1 that match the selected radio option, and sort by unavailable first.
            remainingVariants = getVariantData().filter(function (variant) {
              return variant.option1 === checkedBtns[0].value;
            }).sort(function (variant) {
              return variant.available ? 1 : -1;
            });
          } else if (variantFieldsets.length > 2) {
            //if three variants, find all the variants from option1 and option2 that match the selected values for 1 & 2, and sort by unavailable first.
            remainingVariants = getVariantData().filter(function (variant) {
              return variant.option1 === checkedBtns[0].value && variant.option2 === checkedBtns[1].value;
            }).sort(function (variant) {
              return variant.available ? 1 : -1;
            });
          }
          //console.log(index);
          //console.log({remainingVariants});
          remainingVariants.forEach(function (variant) {
            //if one variant, highlight the unavailable options.
            if (variantFieldsets.length === 1) {
              productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
            }

            //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
            if (variantFieldsets.length >= 2) {
              if (variant.available) {
                productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove('js-unavailable-variant');
              } else {
                productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add('js-unavailable-variant');
              }
            }

            //if there is three variants, same as above.
            if (variantFieldsets.length > 2) {
              if (variant.available) {
                productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove('js-unavailable-variant');
              } else {
                productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add('js-unavailable-variant');
              }
            }
          });
        }
        //Second Radio Option
        if (index === 1) {
          // console.log('fire option 2');
          var _remainingVariants;
          if (variantFieldsets.length === 2) {
            //if two variants, then find all the variants from option2 that match the selected radio option, and sort by unavailable first.
            _remainingVariants = getVariantData().filter(function (variant) {
              return variant.option2 === checkedBtns[1].value;
            }).sort(function (variant) {
              return variant.available ? 1 : -1;
            });
          } else if (variantFieldsets.length > 2) {
            //if three variants, find all the variants from option2 and option3 that match the selected values for 2 & 3, and sort by unavailable first.
            _remainingVariants = getVariantData().filter(function (variant) {
              return variant.option2 === checkedBtns[1].value && variant.option3 === checkedBtns[2].value;
            }).sort(function (variant) {
              return variant.available ? 1 : -1;
            });
          }
          //console.log(index);
          //console.log({remainingVariants});
          _remainingVariants.forEach(function (variant) {
            //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
            if (variantFieldsets.length >= 2) {
              if (variant.available) {
                productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove('js-unavailable-variant');
              } else {
                productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
              }
            }

            //if there is three variants, same as above.
            if (variantFieldsets.length > 2) {
              if (variant.available) {
                productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove('js-unavailable-variant');
              } else {
                productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add('js-unavailable-variant');
              }
            }
          });
        }

        //Third Radio Option
        if (index === 2) {
          //console.log('fire option 3');
          //find all the variants from option3 and option1 that match the selected values for 3 & 1, and sort by unavailable first.
          var _remainingVariants2 = getVariantData().filter(function (variant) {
            return variant.option3 === checkedBtns[2].value && variant.option1 === checkedBtns[0].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
          //console.log(index);
          //console.log({remainingVariants});
          _remainingVariants2.forEach(function (variant) {
            if (variant.available) {
              productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
            }
            if (variant.available) {
              productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelectorAll(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add('js-unavailable-variant');
            }
          });
        }
      });
    };

    //BG: For each radio button, attach an event listener that triggers when it's checked/unchecked.  
    userSelect.forEach(function (radio) {
      return radio.addEventListener('change', function () {
        //After a selection has been made, gather all checked options.
        var selectedOptionChecked = productVariants.querySelectorAll('option:checked');
        var radioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');

        //By default, we assume there will always be one radio button checked.
        var optionCombineSelect = selectedOptionChecked[0].value;

        //if there are two variant fields, we assume there will be two checked radio btns so add this to the variable.
        if (variantFieldsets.length >= 2) {
          //console.log(radioBtnsChecked[0].value);
          optionCombineSelect += ' / ' + radioBtnsChecked[0].value;
        }
        //if there are three variant fields, we assume there will be three checked radio btns so add this to the variable.
        if (variantFieldsets.length > 2) {
          //console.log(radioBtnsChecked[2].value);
          optionCombineSelect += ' / ' + radioBtnsChecked[2].value;
        }

        //BG: with the combined result we search for the variant based on the variant.title.
        var combineVariant = getVariantData().filter(function (variant) {
          return variant.title === optionCombineSelect;
        });
        //console.log({combineVariant});
        finalVariant(combineVariant[0]);
        fieldsetLegend(radio);
        remainingOptions(radioBtnsChecked);
      });
    });
    var currentBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked') || productVariants.querySelectorAll('option:checked');
    ;
    remainingOptions(currentBtnsChecked);
  };
  var variantSingle = document.querySelector('.single-variant');
  if (!variantSingle) {
    productVariants();
  }
};
for (var i = 0; i < productBuyBoxes.length; i++) {
  _loop(i);
}

// ---------------------------------------------------------------------------
// PDP - Updating input quantity on selectors
// ---------------------------------------------------------------------------

function updateInputQuantity(value) {
  var inputFields = document.getElementsByClassName('input-quantity');
  for (var i = 0; i < inputFields.length; i++) {
    inputFields[i].value = value;
  }
}

// Function to handle decrease button click
function handleDecreaseButtonClick() {
  var inputField = this.parentElement.querySelector('.input-quantity');
  var currentQuantity = parseInt(inputField.value);
  if (currentQuantity > 1) {
    updateInputQuantity(currentQuantity - 1);
  }
}

// Function to handle increase button click
function handleIncreaseButtonClick() {
  var inputField = this.parentElement.querySelector('.input-quantity');
  var currentQuantity = parseInt(inputField.value);
  var availableQuantity = parseInt(inputField.getAttribute('max'));
  if (currentQuantity < availableQuantity) {
    updateInputQuantity(currentQuantity + 1);
  }
}

// Add event listeners to the buttons
var decreaseButtons = document.querySelectorAll('.decrease-quantity-btn');
decreaseButtons.forEach(function (button) {
  button.addEventListener('click', handleDecreaseButtonClick);
});
var increaseButtons = document.querySelectorAll('.increase-quantity-btn');
increaseButtons.forEach(function (button) {
  button.addEventListener('click', handleIncreaseButtonClick);
});

// ---------------------------------------------------------------------------
// PDP - Updating variant values to match both
// ---------------------------------------------------------------------------

// MB: Function to update variant values when a select element with the class .js-variant-selector changes
function updateVariantValues() {
  // MB: Get all select elements with the class .js-variant-selector
  var selectElements = document.querySelectorAll(".js-variant-selector");

  // MB: Get all div elements with the class .js-variant-value
  var variantValueDivs = document.querySelectorAll('[data-fieldset-position="1"] .js-variant-value');

  // MB: Get the selected value and text from the changed select
  var selectedValue = this.value;
  var selectedText = this.options[this.selectedIndex].text;

  // MB: Update the text in each div with the selected option
  variantValueDivs.forEach(function (div) {
    div.textContent = selectedText;
  });

  // MB: Update the selected option in the other select elements
  selectElements.forEach(function (otherSelect, otherIndex) {
    if (otherSelect !== this) {
      // MB: Find the option with the same value and set it as selected
      var optionToSelect = otherSelect.querySelector("option[value=\"".concat(selectedValue, "\"]"));
      if (optionToSelect) {
        optionToSelect.selected = true;
      }
    }
  }, this); // <--- passing `this` as the second argument to the forEach function

  // MB: Get the data-variant-id attribute value from the selected option
  var dataVariantId = this.options[this.selectedIndex].getAttribute("data-variant-id");

  // MB: Update the value of input with class .js-variant-id with the data-variant-id value
  var variantIdInput = document.querySelector(".js-variant-id");
  if (variantIdInput) {
    variantIdInput.value = dataVariantId;
  }
  updateCartButtons(this);
  setTimeout(duplicateRechargeContent, 1500);
}

// MB: Function to update cart buttons based on the main select element
function updateCartButtons(mainSelect) {
  // MB: Find the closest form element for the changed select
  var mainForm = mainSelect.closest("form");

  // MB: Get the "main" button that's inside the closest form
  var mainButton = mainForm.querySelector(".js-cart-button");
  if (mainButton) {
    // MB: Get all forms with a select element
    var allForms = document.querySelectorAll("form");

    // MB: Loop through all forms and update the other button closest to the select element
    allForms.forEach(function (form) {
      if (form !== mainForm) {
        var otherButton = form.querySelector(".js-cart-button");
        if (otherButton) {
          otherButton.className = mainButton.className;
          otherButton.disabled = mainButton.disabled;
          otherButton.textContent = mainButton.textContent;
        }
      }
    });
  }
}

// MB: Get all select elements with the class .js-variant-selector
var selectElements = document.querySelectorAll(".js-variant-selector");

// MB: Add event listener to each select element
selectElements.forEach(function (select) {
  // MB: Bind the updateVariantValues function to the select element
  var boundUpdateVariantValues = updateVariantValues.bind(select);
  select.addEventListener("change", boundUpdateVariantValues);
});

// MB: Function to update fieldsets based on the selected radio label
function updateFieldsets() {
  var container = document.querySelector(".product-container");

  // MB: Get all fieldsets with data-fieldset-position="2" inside the container
  var fieldsets = container.querySelectorAll('fieldset[data-fieldset-position="2"]');

  // MB: Loop through each fieldset and perform the updates
  fieldsets.forEach(function (fieldset) {
    var radioContainers = fieldset.querySelectorAll('.variant-radio');
    radioContainers.forEach(function (radioContainer) {
      var radioLabel = radioContainer.querySelector('.js-variant-label');
      var radioInput = radioContainer.querySelector('.user-select');
      radioLabel.addEventListener('click', function () {
        updateLabels(fieldset, radioLabel.textContent);
      });
    });
  });
  function updateLabels(currentFieldset, labelText) {
    var fieldsetsWithSamePosition = container.querySelectorAll('fieldset[data-fieldset-position="2"]');
    fieldsetsWithSamePosition.forEach(function (fieldset) {
      if (fieldset !== currentFieldset) {
        var fieldsetLabel = fieldset.querySelector('.js-variant-value');
        fieldsetLabel.textContent = labelText;

        // MB: Find all .user-select elements inside the current fieldset
        var userSelects = fieldset.querySelectorAll('.user-select');
        userSelects.forEach(function (userSelect) {
          // MB: Check if the value of the .user-select matches the labelText
          if (userSelect.value === labelText) {
            userSelect.checked = true;
          } else {
            userSelect.checked = false;
          }
        });
      }
    });
  }
}

// MB: Call the function to update fieldsets
updateFieldsets();

// MB: Function to duplicate recharge content
function duplicateRechargeContent() {
  // MB: Find the element with class subscription-widget
  var parentElement = document.querySelector('.subscription-widget');
  if (parentElement) {
    // MB: Get the inner HTML of the subscription-widget element
    var htmlContent = parentElement.innerHTML;

    // MB: Find the element with class .js-recharge
    var rechargeElement = document.querySelector('.js-recharge');
    if (rechargeElement) {
      // MB: Function to update the active class for .rc-radio elements in .js-recharge
      var updateActiveClass = function updateActiveClass() {
        var rcRadioElements = rechargeElement.querySelectorAll('.rc-radio');
        rcRadioElements.forEach(function (rcRadio) {
          var radioInput = rcRadio.querySelector('input[type="radio"]');
          if (radioInput.checked) {
            rcRadio.classList.add('rc_widget__option--active');
            rcRadio.classList.add('rc-option--active');
          } else {
            rcRadio.classList.remove('rc_widget__option--active');
            rcRadio.classList.remove('rc-option--active');
          }
        });
      }; // MB: Add event listeners to the radio buttons in .js-recharge to update subscription-widget
      // MB: Set the inner HTML of the .js-recharge element to the content of subscription-widget
      rechargeElement.innerHTML = htmlContent;
      var radioButtons = rechargeElement.querySelectorAll('input[type="radio"]');
      radioButtons.forEach(function (radio) {
        radio.addEventListener('change', function () {
          var name = this.getAttribute('name');
          var value = this.value;

          // MB: Find the corresponding radio button in subscription-widget and update it
          var parentRadio = parentElement.querySelector("input[name=\"".concat(name, "\"][value=\"").concat(value, "\"]"));
          if (parentRadio) {
            parentRadio.checked = true;
          }
          updateActiveClass();
        });
      });

      // MB: Add event listeners to the radio buttons in subscription-widget to update .js-recharge
      var parentRadioButtons = parentElement.querySelectorAll('input[type="radio"]');
      parentRadioButtons.forEach(function (parentRadio) {
        parentRadio.addEventListener('change', function () {
          var name = this.getAttribute('name');
          var value = this.value;

          // MB: Find the corresponding radio button in .js-recharge and update it
          var rechargeRadio = rechargeElement.querySelector("input[name=\"".concat(name, "\"][value=\"").concat(value, "\"]"));
          if (rechargeRadio) {
            rechargeRadio.checked = true;
          }
          updateActiveClass();
        });
      });
    }
  }

  // MB: Find the div with class "active" on page load
  var activeDiv = document.querySelector('.js-recharge .rc_widget__option--active');
  if (activeDiv) {
    // MB: Find the radio input inside the active div and set it as checked
    var activeRadioInput = activeDiv.querySelector('input[type="radio"]');
    if (activeRadioInput) {
      activeRadioInput.checked = true;
    }
  }
}

// MB: Delay execution using setTimeout
setTimeout(duplicateRechargeContent, 1500);

// ---------------------------------------------------------------------------
// PDP - Product Tabs
// ---------------------------------------------------------------------------

function headingTabs(htag) {
  // Cache Tabs container and tab data source
  var tabContainers = document.querySelectorAll('.jsTabsContainer');
  tabContainers.forEach(function (container) {
    var source = container.getAttribute('data-source');

    // Create Tabs menu and content wrapper within container
    var tabsWrapper = document.createElement('div');
    tabsWrapper.className = 'js-product-tabs-wrapper';
    container.appendChild(tabsWrapper);

    // Hide DOM content
    document.querySelectorAll('[data-js]').forEach(function (element) {
      element.style.display = "none";
    });
    var tabs = document.querySelectorAll(source + ' ' + htag);
    var tabCount = tabs.length; // Count the number of tabs

    tabs.forEach(function (element, index) {
      // Create tab
      var title = element.textContent;
      var tab = document.createElement('span');
      var link = document.createElement('a');
      link.href = '#tab' + index;
      link.textContent = title;
      tab.appendChild(link);
      tabsWrapper.appendChild(tab);
      var tabWidthClass = 'lg:w-1/' + tabCount; // Calculate tab width class
      tab.classList.add('js-product-tab', 'tabBg', tabWidthClass);
      link.classList.add('js-product-tab-anchor', 'tabBg');

      // Get tab content
      var i = 0;
      var step = element;
      var tabContent = [];
      while (i < 100) {
        i++;
        var nextStep = step.nextElementSibling;
        if (nextStep && nextStep.tagName !== 'H5') {
          tabContent.push(nextStep.outerHTML);
          step = nextStep;
          continue;
        }
        break;
      }

      // Set tab content
      var tabPane = document.createElement('div');
      tabPane.innerHTML = tabContent.join('');
      tabPane.id = 'tab' + index;
      tabsWrapper.appendChild(tabPane);
      tabPane.classList.add('js-product-tab-content');
    });
  });

  // Init all tabs
  document.querySelectorAll('.jsTabsContainer .js-product-tabs-wrapper').forEach(function (tabsUl) {
    var links = tabsUl.querySelectorAll('.js-product-tab-anchor');
    var active = links[0];
    active.classList.add('active');
    var content = document.querySelector(active.getAttribute('href'));
    Array.from(links).slice(1).forEach(function (link) {
      document.querySelector(link.getAttribute('href')).style.display = 'none';
    });
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        active.classList.remove('active');
        content.style.display = 'none';
        active = link;
        content = document.querySelector(link.getAttribute('href'));
        active.classList.add('active');
        content.style.display = 'block';
      });
    });
  });
}
headingTabs('h5');

// ---------------------------------------------------------------------------
// PDP - Product Variant Image Switch
// ---------------------------------------------------------------------------

setTimeout(function () {
  // MB: Gets the data from the product carousel
  var flkty = Flickity.data('.product-carousel');

  // MB: Getting each image from the carousel
  var carouselItem = document.querySelectorAll('.product-carousel .carousel-cell img');

  // MB: Looping through all select fields on the page (.js-variant-selector)
  selectElements.forEach(function (select) {
    return select.addEventListener('change', function (event) {
      // MB: Get the selected option within the specific select element that triggered the event
      var selectedOption = select.options[select.selectedIndex];

      // MB: Check if the selected option has the data-variant-image attribute
      var optionImageURL = selectedOption.dataset.variantImage;

      // MB: If the selected option exists
      if (!!optionImageURL) {
        // MB: Loop through each carousel image
        carouselItem.forEach(function (item, i) {
          // MB: If the image attribute (data-image-src) matches the data-variant-image attribute
          if (item.dataset.imageSrc === optionImageURL) {
            // MB: Use Flickity to select that image
            flkty.select(i);
          }
        });
      }
    });
  });
}, 1000);
})();

/******/ })()
;